import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW0900Model } from "../kymw0900.model";

/**
 * 曜日別当選数取得サービス
 *
 * @export NumberOfUsersService
 * @class NumberOfUsersService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class NumberOfUsersService extends PlessJsonResponderSub<any> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof NumberOfUsersService
   */
  private successFunc: Function;

  item: any;
  model: KYMW0900Model;

  vo = {
    winningGoodsNum: 0,
  };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof NumberOfUsersService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        WinningGoodsNum: this.vo.winningGoodsNum
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof NumberOfUsersService
   */
  execute(vo: any, successFunc: Function = null): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getNumberOfUsers', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof NumberOfUsersService
   */
  success(data: any): void {
    if (data) {
      this.item.mondayPlanNum = data.MondayPlanNum;
      this.item.tuesdayPlanNum = data.TuesdayPlanNum;
      this.item.wednesdayPlanNum = data.WednesdayPlanNum;
      this.item.thursdayPlanNum = data.ThursdayPlanNum;
      this.item.fridayPlanNum = data.FridayPlanNum;

      this.model.kymw0900Component.eventDayOfWeekPlanNum_FOCUS_OUTHandler(this.item);
    }
    if (data != null) {
      this.successFunc();
    }
  }

  /**
   * async/await 記述用
   *
   * @param model
   * @returns Promise<void>
   */
  public executeAsync(vo: any, item: any, model: KYMW0900Model): Promise<void> {
    this.item = item;
    this.model = model;
    return new Promise(resolve => {
      this.execute(
        vo,
        () => resolve(),
      );
    });
  }
}
